import { WrapperGS, WrapperValued } from '../core/WrapperGS';

export class ProgressGS extends WrapperGS<HTMLProgressElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "progress";
    }

    constructor(el: HTMLProgressElement|string)
    {
        super(el);
    }

    public get value() { return this.el.value; }
    public set value(value: number) { this.el.value = value; }

    public get max() { return this.el.max; }
    public set max(value: number) { this.el.max = value; }

    public get position() { return this.el.position; }
    public get percent() { return this.max > 0 ? (this.value / this.max) * 100 : 0; }
}
WrapperGS.ExtendComponentsByHTMLElement(ProgressGS);
